// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bNeLw7IFmgRIIIVuaXbl {
  position: relative;
}

.waqviKmbOAEKvTTpmeKF {
  padding-bottom: 71px;
}

.E38tkiuD6whJ5SLmridL {
  display: flex;
  flex-direction: column;
}
.EKgBHZnpDDzZii1jGadp {
  padding: 20px 0;
}

.sofaMHIBgg7r9T0zcovA {
  display: grid;
  grid-template-columns: 0.7fr 2.8fr 0.7fr;
  align-items: center;
  gap: 5px;
  margin-bottom: 45px;
}

.WRVasn55nhXVBAlGh9oF {
  color: #1c77ff;
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border: none;
  transition: color 0.3s ease 0s;
  justify-content: flex-end;
}

.WRVasn55nhXVBAlGh9oF:first-child {
  justify-content: flex-start;
}

.WRVasn55nhXVBAlGh9oF:hover {
  color: #055ada;
  background: transparent;
}

.ZBmnVkjPfuWG6nWw9HjL {
  font-size: 17px;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  text-align: center;
  margin: 0 auto;
}

.koBju9DBuL36tGSgkKWS,
.rKbyGVp8tfsAAeanHt8g {
  cursor: pointer;
}

.vomC1ZxCvErt5urY_YGQ:not(:first-child) {
  margin-top: 20px;
}

/*--------------------info--------------------*/
.RP_87Uprb5oG3v31vLuw {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.rKbyGVp8tfsAAeanHt8g {
  font-weight: 510;
  font-size: 24px;
  text-align: center;
}
.YrnZ6Fa94lRPAJGmt5rt {
  /* margin: 33px 0; */
  padding: 20px 16px;
  border-radius: 32px;
  background: rgba(var(--secondary-bg), 0.24);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px); 
}
.vomC1ZxCvErt5urY_YGQ {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-secondary));
  margin-bottom: 12px;
  padding-left: 8px;
}
.KF46McllDxgRyxfRfexG {
  padding: 8px 16px;
  border-radius: 24px;
  background: rgba(var(--secondary-bg-dark), 0.30); 
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
}



._JJrFJl_TIpvVpE2Msfs:not(:last-child) {
  margin-bottom: 8px;
}

._JJrFJl_TIpvVpE2Msfs {
  padding: 19px 10px 19px 10px;
  border-radius: 24px;
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
  background: transparent;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; 
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-primary));
  transition: background 0.3s ease 0s;
}
._JJrFJl_TIpvVpE2Msfs:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .action:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.n_Adu9fqC2k6U_Ii1IYp {
  color: rgb(var(--accent-error-dark)) !important;
}


._JJrFJl_TIpvVpE2Msfs:not(:last-child):after {
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: -4px;
  right: 0;
  background: rgb(var(--tertiary-bg-dark));
}

.FYgd0hyE8IervOrybfet:last-child {
  margin-top: -10px;
}
/*--------------------contacts--------------------*/

.PQtwp4apjhmVlX1IABkT {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
}
.PQtwp4apjhmVlX1IABkT > img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}

.Ok7Q6oGcpXUl4iUmgig7 {
  font-size: 17px;
  font-weight: 540;
  line-height: 129%;
  margin-bottom: 10px;
}

._VYwVMJ5JnXeN3aQGKCh {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
/*--------------------/contacts--------------------*/

/*--------------------/info--------------------*/

/*--------------------password--------------------*/
.Qau1ZOPcJUyYie8Ew3_6 {
  display: flex;
  flex-direction: column;
}
.VG6BIyX0SPdwlclRff1N {
  border-radius: 20px;
  background: rgba(var(--tertiary-bg-dark), 0.30);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  padding: 12px 16px 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.wcDm6iRDI3nh_7gaXBAZ {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  flex: 1;
}

.v6GEqeGnaYdS3F4sJxzH {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-tertiary));
}

.IEkb3cPVfWYY7n43PLcj {
  width: 100%;
  background: transparent;
  border: none;
  color: rgb(var(--placeholder-primary));
  max-width: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;

  caret-color: rgb(var(--accent-brand)); 

  outline: none;
}
.IEkb3cPVfWYY7n43PLcj::placeholder {
  color: rgb(var(--placeholder-tertiary))
}

.IEkb3cPVfWYY7n43PLcj::-ms-reveal,
.IEkb3cPVfWYY7n43PLcj::-ms-clear {
  display: none;
}

.PU2Sw5XEd75igBsl0Hzr {
  background: transparent;
}
/* ----- */


.R84Ap8eIPB7OyTdCnWb4 {
  margin: auto 0 10px 0;
  color: #fff;
  background: #007aff;
  border-radius: 12px;
  font-size: 17px;
  padding: 14px;
  width: 100%;
}
/*--------------------/password--------------------*/

/*--------------------private info--------------------*/

.b6jtoacKh_FreASswpU3 {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.CzfDGHLQmsBYg5DJQnLQ {
  padding: 34px 24px;
  text-align: center;
  color: #fff;
  border-radius: 12px;
  background: #ff3b30;
  margin-bottom: 12px;
}

.FTjWlm6WuBDzm7rWL0dO {
  font-size: 20px;
  font-weight: 760;
  line-height: 120%;
  margin-bottom: 12px;
  color: #000;
}

.vgdVUhGWyF10SVJ56HWK {
  border-radius: 20px;
  background: rgba(var(--secondary-bg), 0.30);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

}

.SAkuGItGoTMbSGLRBaVN {
  word-wrap: break-word;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}

.JK6y27BNT3SodcWWMR4W {
  width: 100%;
  height: 1px;
  background: rgb(var(--tertiary-bg-dark));
}

.Dwwk4C2K_xr0MDAO8XPY {
  background: transparent;
  display: flex;
  justify-content: flex-start;
  color: rgb(var(--placeholder-primary));
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;
}

/*--------------------/private info--------------------*/

/*--------------------recovery words--------------------*/

.RMGVvn22mg5Jjr63v4H4 {
  padding: 16px;
  border-radius: 24px;
  border: 1px solid rgba(var(--border-dark), 0.20);
  background: rgb(var(--secondary-bg));
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dmHal_ah_zkLlAcIx7BI {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
}

.rRxZuFLN8rylmmSktPhE {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  background: rgba(var(--tertiary-bg-dark), 0.60);
  backdrop-filter: blur(28px);
  -webkit-backdrop-filter: blur(28px); 
}

.bxUk0hHCe7pKgC8dErDx {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-primary));
}

/*--------------------/recovery words--------------------*/

/*--------------------alert--------------------*/

.KbZ2sMRwGHFmDurt5TZg {
  color: #fff;
  background: rgb(var(--accent-brand));
  border: 0;
  border-radius: 10px 0 0 10px;
}

.KbZ2sMRwGHFmDurt5TZg > button {
  color: #fff !important;
}
  
/*--------------------/alert--------------------*/

.IM57aLJF2DjuQtI6OdFZ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.IM57aLJF2DjuQtI6OdFZ > img {
  border-radius: 50%;
  max-width: 60px;
  max-height: 60px;
}

.ZuJmVXfl5nBN7ciS72_P {
  color: #000;
  font-size: 22px;
  font-weight: 560;
  letter-spacing: 0.066px;
}

.bFH1_TnK7ZZnfiP41lDS {
  font-weight: 510;
  font-size: 15px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/settings/settings.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,2BAA2B;EAC3B,mCAAmC;AACrC;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,+CAA+C;AACjD;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;AACA,mDAAmD;;AAEnD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA,oDAAoD;;AAEpD,gDAAgD;;AAEhD,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;;EAEtB,qCAAqC;;EAErC,aAAa;AACf;AACA;EACE;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA,UAAU;;;AAGV;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,WAAW;AACb;AACA,oDAAoD;;AAEpD,uDAAuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;;AAEX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,uBAAuB;AACzB;;AAEA,wDAAwD;;AAExD,yDAAyD;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,0DAA0D;;AAE1D,gDAAgD;;AAEhD;EACE,WAAW;EACX,oCAAoC;EACpC,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".wrapper {\n  position: relative;\n}\n\n.bottomPadding {\n  padding-bottom: 71px;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n}\n.paddingsModal {\n  padding: 20px 0;\n}\n\n.modalTop {\n  display: grid;\n  grid-template-columns: 0.7fr 2.8fr 0.7fr;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 45px;\n}\n\n.modalTopButton {\n  color: #1c77ff;\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  transition: color 0.3s ease 0s;\n  justify-content: flex-end;\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  color: #055ada;\n  background: transparent;\n}\n\n.modalTitle {\n  font-size: 17px;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.copyAddress,\n.infoAddress {\n  cursor: pointer;\n}\n\n.actionsTitle:not(:first-child) {\n  margin-top: 20px;\n}\n\n/*--------------------info--------------------*/\n.info {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.infoAddress {\n  font-weight: 510;\n  font-size: 24px;\n  text-align: center;\n}\n.actions {\n  /* margin: 33px 0; */\n  padding: 20px 16px;\n  border-radius: 32px;\n  background: rgba(var(--secondary-bg), 0.24);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px); \n}\n.actionsTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 125% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-secondary));\n  margin-bottom: 12px;\n  padding-left: 8px;\n}\n.actionsInner {\n  padding: 8px 16px;\n  border-radius: 24px;\n  background: rgba(var(--secondary-bg-dark), 0.30); \n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n}\n\n\n\n.action:not(:last-child) {\n  margin-bottom: 8px;\n}\n\n.action {\n  padding: 19px 10px 19px 10px;\n  border-radius: 24px;\n  cursor: pointer;\n  border: none;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; \n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-primary));\n  transition: background 0.3s ease 0s;\n}\n.action:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .action:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.actionDanger {\n  color: rgb(var(--accent-error-dark)) !important;\n}\n\n\n.action:not(:last-child):after {\n  content: '';\n  width: 100%;\n  height: 1px;\n  position: absolute;\n  bottom: -4px;\n  right: 0;\n  background: rgb(var(--tertiary-bg-dark));\n}\n\n.actionDelete:last-child {\n  margin-top: -10px;\n}\n/*--------------------contacts--------------------*/\n\n.contacts {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 10px;\n}\n.contacts > img {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n}\n\n.contactsTitle {\n  font-size: 17px;\n  font-weight: 540;\n  line-height: 129%;\n  margin-bottom: 10px;\n}\n\n.contactsRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n/*--------------------/contacts--------------------*/\n\n/*--------------------/info--------------------*/\n\n/*--------------------password--------------------*/\n.passwordBlock {\n  display: flex;\n  flex-direction: column;\n}\n.passwordInner {\n  border-radius: 20px;\n  background: rgba(var(--tertiary-bg-dark), 0.30);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  padding: 12px 16px 12px 16px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.passwordWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1;\n}\n\n.passwordLabel {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-tertiary));\n}\n\n.passwordInput {\n  width: 100%;\n  background: transparent;\n  border: none;\n  color: rgb(var(--placeholder-primary));\n  max-width: 100%;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n\n  caret-color: rgb(var(--accent-brand)); \n\n  outline: none;\n}\n.passwordInput::placeholder {\n  color: rgb(var(--placeholder-tertiary))\n}\n\n.passwordInput::-ms-reveal,\n.passwordInput::-ms-clear {\n  display: none;\n}\n\n.eyeBtn {\n  background: transparent;\n}\n/* ----- */\n\n\n.btn {\n  margin: auto 0 10px 0;\n  color: #fff;\n  background: #007aff;\n  border-radius: 12px;\n  font-size: 17px;\n  padding: 14px;\n  width: 100%;\n}\n/*--------------------/password--------------------*/\n\n/*--------------------private info--------------------*/\n\n.privateInfo {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.privateAlertInfo {\n  padding: 34px 24px;\n  text-align: center;\n  color: #fff;\n  border-radius: 12px;\n  background: #ff3b30;\n  margin-bottom: 12px;\n}\n\n.privateInfoTitle {\n  font-size: 20px;\n  font-weight: 760;\n  line-height: 120%;\n  margin-bottom: 12px;\n  color: #000;\n}\n\n.privateInfoKey {\n  border-radius: 20px;\n  background: rgba(var(--secondary-bg), 0.30);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n}\n\n.privateKetText {\n  word-wrap: break-word;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.line {\n  width: 100%;\n  height: 1px;\n  background: rgb(var(--tertiary-bg-dark));\n}\n\n.btnCopy {\n  background: transparent;\n  display: flex;\n  justify-content: flex-start;\n  color: rgb(var(--placeholder-primary));\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  letter-spacing: -0.07px;\n}\n\n/*--------------------/private info--------------------*/\n\n/*--------------------recovery words--------------------*/\n\n.recoveryWordsWrapper {\n  padding: 16px;\n  border-radius: 24px;\n  border: 1px solid rgba(var(--border-dark), 0.20);\n  background: rgb(var(--secondary-bg));\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.recoveryWords {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.recoveryWord {\n  display: flex;\n  padding: 8px 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 28px;\n  background: rgba(var(--tertiary-bg-dark), 0.60);\n  backdrop-filter: blur(28px);\n  -webkit-backdrop-filter: blur(28px); \n}\n\n.word {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-primary));\n}\n\n/*--------------------/recovery words--------------------*/\n\n/*--------------------alert--------------------*/\n\n.alert {\n  color: #fff;\n  background: rgb(var(--accent-brand));\n  border: 0;\n  border-radius: 10px 0 0 10px;\n}\n\n.alert > button {\n  color: #fff !important;\n}\n  \n/*--------------------/alert--------------------*/\n\n.userTg {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.userTg > img {\n  border-radius: 50%;\n  max-width: 60px;\n  max-height: 60px;\n}\n\n.username {\n  color: #000;\n  font-size: 22px;\n  font-weight: 560;\n  letter-spacing: 0.066px;\n}\n\n.infoAddress2 {\n  font-weight: 510;\n  font-size: 15px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `bNeLw7IFmgRIIIVuaXbl`,
	"bottomPadding": `waqviKmbOAEKvTTpmeKF`,
	"modal": `E38tkiuD6whJ5SLmridL`,
	"paddingsModal": `EKgBHZnpDDzZii1jGadp`,
	"modalTop": `sofaMHIBgg7r9T0zcovA`,
	"modalTopButton": `WRVasn55nhXVBAlGh9oF`,
	"modalTitle": `ZBmnVkjPfuWG6nWw9HjL`,
	"copyAddress": `koBju9DBuL36tGSgkKWS`,
	"infoAddress": `rKbyGVp8tfsAAeanHt8g`,
	"actionsTitle": `vomC1ZxCvErt5urY_YGQ`,
	"info": `RP_87Uprb5oG3v31vLuw`,
	"actions": `YrnZ6Fa94lRPAJGmt5rt`,
	"actionsInner": `KF46McllDxgRyxfRfexG`,
	"action": `_JJrFJl_TIpvVpE2Msfs`,
	"actionDanger": `n_Adu9fqC2k6U_Ii1IYp`,
	"actionDelete": `FYgd0hyE8IervOrybfet`,
	"contacts": `PQtwp4apjhmVlX1IABkT`,
	"contactsTitle": `Ok7Q6oGcpXUl4iUmgig7`,
	"contactsRow": `_VYwVMJ5JnXeN3aQGKCh`,
	"passwordBlock": `Qau1ZOPcJUyYie8Ew3_6`,
	"passwordInner": `VG6BIyX0SPdwlclRff1N`,
	"passwordWrapper": `wcDm6iRDI3nh_7gaXBAZ`,
	"passwordLabel": `v6GEqeGnaYdS3F4sJxzH`,
	"passwordInput": `IEkb3cPVfWYY7n43PLcj`,
	"eyeBtn": `PU2Sw5XEd75igBsl0Hzr`,
	"btn": `R84Ap8eIPB7OyTdCnWb4`,
	"privateInfo": `b6jtoacKh_FreASswpU3`,
	"privateAlertInfo": `CzfDGHLQmsBYg5DJQnLQ`,
	"privateInfoTitle": `FTjWlm6WuBDzm7rWL0dO`,
	"privateInfoKey": `vgdVUhGWyF10SVJ56HWK`,
	"privateKetText": `SAkuGItGoTMbSGLRBaVN`,
	"line": `JK6y27BNT3SodcWWMR4W`,
	"btnCopy": `Dwwk4C2K_xr0MDAO8XPY`,
	"recoveryWordsWrapper": `RMGVvn22mg5Jjr63v4H4`,
	"recoveryWords": `dmHal_ah_zkLlAcIx7BI`,
	"recoveryWord": `rRxZuFLN8rylmmSktPhE`,
	"word": `bxUk0hHCe7pKgC8dErDx`,
	"alert": `KbZ2sMRwGHFmDurt5TZg`,
	"userTg": `IM57aLJF2DjuQtI6OdFZ`,
	"username": `ZuJmVXfl5nBN7ciS72_P`,
	"infoAddress2": `bFH1_TnK7ZZnfiP41lDS`
};
export default ___CSS_LOADER_EXPORT___;
